import { useSelector } from 'react-redux'
import store from 'src/store'

export const useMe = () => useSelector((state: $TSFixMe) => state.settings.user)

export const getMe = () => (store.getState() as $TSFixMe).settings.user
